import { useCallback } from 'react'
import type { ReportBucketType } from '@services/api/reports/finance.api'
import {
  getCollectionsFinancialEfficiencyReport,
  type CollectionsFinancialEfficiencyReportResult,
} from '@services/api/reports/providerPerformance.api'
import { useFinanceReportQuery } from '@hooks/reports/useFinanceReportQuery'

export type CollectionsFinancialEfficiencyData =
  CollectionsFinancialEfficiencyReportResult

export type UseCollectionsFinancialEfficiencyResult = {
  loading: boolean
  error: string | null
  data: CollectionsFinancialEfficiencyData | null
  bucketLabel: string
}

export function useCollectionsFinancialEfficiency(
  toolbarSelection: Record<string, string>,
): UseCollectionsFinancialEfficiencyResult {
  const getBucketFromData = useCallback(
    (data: CollectionsFinancialEfficiencyReportResult): ReportBucketType =>
      data.collections.bucket,
    [],
  )

  return useFinanceReportQuery({
    toolbarSelection,
    fetchReport: getCollectionsFinancialEfficiencyReport,
    getBucketFromData,
    errorMessage: 'Failed to load collections financial efficiency data',
  })
}
